<template>
  <div class="sidepanel-content centerx w-full relative">
    <!-- LOADING-->
    <div
      v-show="triggerLoading"
      id="sidepanel-loader"
      class="vs-con-loading__container loader h-full"
    >
      <span class="text-primary text-xl">{{ $t("general.loading") }}</span>
    </div>

    <!--CONTENT-->
    <div :style="!courseOutlineUnits || courseOutlineUnits.length === 0 ? 'max-height: 70vh; overflow: hidden;' : ''">
      <div v-for="(unit, unitIndex) in courseOutlineUnits" :key="unit.id" class="p-0 bg-white m-0 w-full">
        <vs-collapse accordion class="m-0 w-full sidepanel-unit-item"
                     v-if="unit.vdoSetUnit && unit.vdoSetUnit.status === 'enable'">
          <vs-collapse-item class="w-full">
            <!--COURSE OUTLINE UNIT-->
            <div slot="header" class="w-full items-center mr-4">
              <!--UNIT NO, NAME, LEARNING PROGRESS-->
              <div class="flex justify-between mr-10">
                <p class="mb-1 text-lg">{{ $t('virtual-class.learning-unit') + ' ' + unit.seq }}</p>
                <p class="mb-1 text-lg">{{ getLearnPercent(unit) }}%</p>
              </div>
              <p class="mb-1 text-base  mr-5">{{ unit.nameLocal }}</p>
            </div>

            <div class="pb-1">
              <!-- PRE TEST POST TEST -->
              <ItemTest v-if="(unit.studentUnitTest)"
                        :unit="unit"
                        :canTest="getCanLearn(unitIndex, unit)"
                        @handlerStartTestClick="handlerStartTestClick"/>

              <!-- COURSE OUTLINE TOPIC -->
              <!--  <div v-if="unit.studentUnitTest && unit.studentUnitTest.isPretestDone">-->
              <div>
                <div v-for="(topic, index) in getVdoSetTopics(unit.vdoSetUnit)" :key="topic.id">
                  <ItemLearn
                    :index="index"
                    :studentUnitLearn="unit.studentUnitLearn"
                    :topic="topic"
                    :topicId="topic.id"
                    :topicLength="unit.vdoSetUnit.vdoSetTopics.length"
                    :unit="unit"
                    :canLearn="getCanLearn(unitIndex, unit)"
                    @handlerTopicClick="handlerTopicClick"/>
                </div>
              </div>
            </div>
          </vs-collapse-item>
        </vs-collapse>
        <vs-divider class="w-full m-0 p-0"/>
      </div>
    </div>
  </div>
</template>

<script>
import ItemLearn from "./item-learn";
import ItemTest from "./item-test";

export default {
  props: [
    'studentEnrollDetail',
    'courseOutlineUnits',
    'courseOutlineUnitLoading',
    'handlerTopicClick',
    'handlerStartTestClick',
    'triggerLoading',
  ],
  watch: {
    triggerLoading(val) {
      // console.log('watch triggerLoading', val);//not working
      if (val) {
        this.loaderOn();
      } else {
        this.loaderOff();
      }
    }
  },
  components: {
    ItemLearn,
    ItemTest
  },
  data() {
    return {
      loading: true,
    }
  },
  methods: {
    getLearnPercent(unit) {
      if (unit.studentUnitLearn) {
        return unit.studentUnitLearn.learnPercent > 100 ? 100 : unit.studentUnitLearn.learnPercent
      }
      return 0;
    },
    getVdoSetTopics(vdoSetUnit) {
      if (vdoSetUnit) {
        return vdoSetUnit.vdoSetTopics;
      }
      return [];
    },
    getCanLearn(currUnitIndex) {
      if (!this.courseOutlineUnits || currUnitIndex === 0) {
        return true;
      }

      // check must learn previous unit
      /*for (let i = currUnitIndex; i >= 0; i--) {
        const unitMustLearn = this.courseOutlineUnits[i]; // Current unit must learn
        const prevUnit = this.courseOutlineUnits[i - 1]; // Previous unit to check

        // check if the current unit is the current unit, and it does not require previous unit to learn
        if(i === currUnitIndex && unitMustLearn && !unitMustLearn.mustLearnPrevious) {
          return true
        }

        if (
          prevUnit &&
          unitMustLearn &&
          unitMustLearn.mustLearnPrevious
        ) {
          if (
            prevUnit.studentUnitLearn &&
            prevUnit.studentUnitLearn.learnPercent < unitMustLearn.previousPercentRequireBeforeLearn
          ) {
            return false;
          }
        }
      }*/
      return true;
    },
    //--------------------------------------- Local Data Function ------------------------------
    loaderOn() {
      if (this.$vs) {
        this.isLoaderActive = true;
        this.$vs.loading({container: '#sidepanel-loader', scale: 1})
      }
    },
    loaderOff() {
      if (this.$vs) {
        this.isLoaderActive = false;
        this.$vs.loading.close('#sidepanel-loader > .con-vs-loading')
      }
    },
  },
}
</script>

<style lang="scss">

.sidepanel-content {
  //height: calc(100vh - 205px);
  overflow-y: scroll;

  & .sidepanel-unit-item {
    background: rgb(230, 230, 230);
    border: none;
    border-bottom: 1px solid white;
    border-radius: 0;
    transition: all ease-in 0.1s !important;
    transition-delay: unset !important;

    &:hover {
      color: #5e54c3;
      background: white;
    }
  }
}

#sidepanel-loader {
  width: 100%;
  height: calc(100%);
  margin: auto;
  padding: 0;
  padding-bottom: 100px;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  z-index: 999;
  background: #d2d2d28c;

  & > .con-vs-loading {
    background: #a2a2a24a;
  }
}

</style>
